import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment.local';
import {IGlobalDataResponse} from '../models/i-global-data-response';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AppApi {
  http: HttpClient = inject(HttpClient);

  readonly GLOBAL_URL: string = `${environment.apiUrl}/api/global`;
  readonly HEALTH_URL: string = `${environment.apiUrl}/api/health`;

  getGlobalData(): Observable<IGlobalDataResponse> {
    return this.http.get<IGlobalDataResponse>(this.GLOBAL_URL);
  }

  healthCheck(): Observable<string> {
    return this.http.get(this.HEALTH_URL, { responseType: 'text' });
  }
}
